import {
  ConsentCategory,
  getCookieConsent,
} from '@packages/shared/src/utils/getCookieConsent/getCookieConsent';

const MIRAKL_P_COOKIE_NAME = 'mirakl-p';
const MIRAKL_ANALYTICS_COOKIE_NAME = 'mirakl-analytics';

/**
 * Get Mirakl user ID from cookies.
 * Mirakl sets two cookies for tracking:
 * - mirakl-p: Publisher tracking cookie (primary)
 * - mirakl-analytics: Analytics tracking cookie (fallback)
 *
 * These cookies are set by Mirakl's tracking pixels when sponsored products are displayed.
 *
 * @param cookies - Record of cookie name-value pairs
 * @returns Mirakl user ID if marketing consent is given and cookie exists, undefined otherwise
 */
export const getMiraklUserId = (cookies: Record<string, string>): string | undefined => {
  if (!getCookieConsent(cookies, ConsentCategory.Marketing)) return undefined;

  const {
    [MIRAKL_P_COOKIE_NAME]: cookieName,
    [MIRAKL_ANALYTICS_COOKIE_NAME]: analyticsCookieName,
  } = cookies;

  return cookieName || analyticsCookieName || undefined;
};
